<template>
<div>
    <notifications group="app"></notifications>
    <Inform ref="Inform"></Inform>
    <Confirm ref="Confirm"></Confirm>
    <LoadingComponent v-if="isShowLoading"></LoadingComponent>
    <TextEditor ref="TextEditor"></TextEditor>
    <FileSelector ref="FileSelector"></FileSelector>
    <Modals/>
</div>
</template>

<script>
import Confirm from '@/modules/fptai/components/Confirm'
import Inform from '@/modules/fptai/components/Inform'
import { AppEventBus, AppEventBusType } from '@/eventbus/app.eventbus'
import LoadingComponent from '@/modules/fptai/components/LoadingComponent'
import { mapState } from 'vuex'
import TextEditor from '@/components/TextEditor'
import FileSelector from '@/components/FileSelector'
import Modals from '@/components/Modals'

export default {
    name: 'AppServiceView',
    components: {
        Modals,
        FileSelector,
        TextEditor,
        LoadingComponent,
        Confirm,
        Inform
    },
    computed: {
        ...mapState({
            isShowLoading: state => state.isShowLoading
        })
    },
    mounted () {
        AppEventBus.on(AppEventBusType.INFORM, ({
            message,
            options
        }) => {
            this.$refs.Inform.open(message, options)
        })
        AppEventBus.on(AppEventBusType.CLOSE_INFORM, () => {
            this.$refs.Inform.close()
        })
        AppEventBus.on(AppEventBusType.TOAST, options => {
            this.$notify(options)
        })
        AppEventBus.on(AppEventBusType.CONFIRM, message => {
            this.$refs.Confirm.open(message).then(
                result => AppEventBus.emit(AppEventBusType.CONFIRM + '_DONE', result)
            )
        })
        AppEventBus.on(AppEventBusType.EDIT_TEXT, data => {
            this.$refs.TextEditor.open(data).then(
                result => AppEventBus.emit(AppEventBusType.EDIT_TEXT + '_DONE', result)
            )
        })
        AppEventBus.on(AppEventBusType.SELECT_FILE, data => {
            this.$refs.FileSelector.open(data).then(
                result => AppEventBus.emit(AppEventBusType.SELECT_FILE + '_DONE', result)
            )
        })
    }
}
</script>

<style>
    .notifications {
        top: 15px !important;
        right: 15px !important;
    }

    .vue-notification {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        border-radius: 3px;
    }
</style>
